import { render, staticRenderFns } from "./input-aspect-ratio.vue?vue&type=template&id=2651938e&scoped=true"
import script from "./input-aspect-ratio.vue?vue&type=script&lang=js"
export * from "./input-aspect-ratio.vue?vue&type=script&lang=js"
import style0 from "./input-aspect-ratio.vue?vue&type=style&index=0&id=2651938e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651938e",
  null
  
)

export default component.exports